import { spacingVars } from '@tundr/ds-foundations';
import { semanticTokenVars } from '@tundr/ds-tokens';
import { style } from '@vanilla-extract/css';

const SLIDEOVER_PADDING = spacingVars['3xl'];

export const slideoverSkeletonContainerClass = style({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
});

export const slideoverHeaderSlotClass = style({
  flex: '0 0 auto',
  padding: `${SLIDEOVER_PADDING} ${SLIDEOVER_PADDING} 0`,
  backgroundColor: semanticTokenVars.surface.background.neutral.default.base,
});

export const slideoverContentClass = style({
  flex: '1 1 auto',
  overflowY: 'auto',
  padding: `0 ${SLIDEOVER_PADDING} ${SLIDEOVER_PADDING}`,
});

export const slideoverFooterSlotClass = style({
  flex: '0 0 auto',
  padding: `0 ${SLIDEOVER_PADDING} ${SLIDEOVER_PADDING}`,
  backgroundColor: semanticTokenVars.surface.background.neutral.default.base,
});
